import get from 'lodash/get'

import { getUserForResubscribeQuery } from '../../../apolloClient/operations/userData/getUserForResubscribeQuery'

const { useQuery } = require('@apollo/client')

export const useUserForResubscribe = () => {
  const { data, loading } = useQuery(getUserForResubscribeQuery)
  const userData = get(data, 'getUserProfile')

  return { loadingUserProfile: loading, userData }
}
